import { createSlice } from "@reduxjs/toolkit";
import { enqueueSnackbar } from 'notistack';

import { loadReviews } from '../thunks'


export const reviewsSlice = createSlice({
    name: 'reviews',
    initialState:
    {
        itemsReviews: []
    },
    reducers:
    {
        saludo: (state, action) => {
            console.log('hola mundo');
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadReviews.fulfilled, (state, action) => {
                if (action.payload?.code === '00') {
                    state.itemsReviews = action.payload?.metadata;
                }
                else{
                    state.itemsReviews = [];
                    enqueueSnackbar(action.payload?.message, { variant: 'error', persist: false });
                }
            })
    }
})

export const { 
    saludo,
} = reviewsSlice.actions;